let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2EFah")).then(() => parcelRequire('78kLE'));